import { TransactionModel } from './transaction.model';
import { AttemptStatus, AttemptType } from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';

export class AttemptModel extends Model {
  public RouteId!: string;
  public RouteName!: string;
  public ExecutionDate!: Date;
  public DateOfIssue!: Date;
  public OurCode!: string;
  public Status!: AttemptStatus;
  public LastTransaction!: TransactionModel;
  public CardTruncatedNumber!: string;
  public Type!: AttemptType;
}
